import React from "react";
import { Heading, RadioGroup, Text } from "@telia/teddy";
import cn from "classnames";
import { PickupPoint as PickupPointType } from "../../../../../../models/state";
import "./PickupPoint.less";

interface PickupPointProps extends PickupPointType {
    isSelected: boolean;
}

const PickupPoint: React.FC<PickupPointProps> = ({ isSelected, name, street, zip, city, code }) => (
    <div className={cn("pickup-point", { "pickup-point--selected": isSelected })}>
        <RadioGroup.Item>
            <RadioGroup.Trigger value={code} />
            <RadioGroup.Label>
                <div className="pickup-point--info">
                    <div className="pickup-point--header">
                        <Heading as="h3" variant="title-100" className="pickup-point--heading">
                            {name.toLowerCase()}
                        </Heading>
                        <div className="pickup-point--infologo">
                            {code.toLowerCase().includes("bring") && (
                                <img
                                    width={50}
                                    height={15}
                                    alt="Bring"
                                    src="/shop/assets/img-static/delivery/posten-logo.png"
                                />
                            )}
                            {code.toLowerCase().includes("postnord") && (
                                <img
                                    width={50}
                                    height={12}
                                    alt="Postnord"
                                    src="/shop/assets/img-static/delivery/postnord-logo.png"
                                />
                            )}
                        </div>
                    </div>
                    <div className="pickup-point--infotext">
                        <Text mb="100" variant="additional-100">
                            {`${street}`.toLowerCase()}
                        </Text>
                        <Text mb="100" variant="additional-100">
                            {`${zip} ${city}`.toLowerCase()}
                        </Text>
                    </div>
                </div>
            </RadioGroup.Label>
        </RadioGroup.Item>
    </div>
);
export default PickupPoint;
